import { useEffect, useState } from "react";
import { MapPin, ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";
import api from "../api/api";
import FeaturedLoader from "../components/Loaders/FeaturedLoader";


export default function PopularDestinations() {
    const [destinations, setDestinations] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        api.get("/destinations")
            .then((response) => {
                setDestinations(response.data);
            })
            .catch((error) => {
                console.error("Error fetching destinations:", error);
            })
            .finally(() => {
                setLoading(false);
            });
    }, []);


    if (loading) {
        return (
            <FeaturedLoader
                title="Loading featured hotels"
                subtitle="Preparing the best deals for you..."
            />
        );
    }

    return (
        <section className="py-24 bg-white dark:bg-gray-950">
            <div className="container mx-auto px-6">

                {/* Section Header */}
                <div className="text-center mb-14">

                    <span className="inline-block px-4 py-2 rounded-full bg-blue-100 text-blue-600 text-sm font-semibold mb-4">
                        Explore UAE
                    </span>

                    <h2 className="text-4xl font-bold text-gray-900 dark:text-white mb-3">
                        Popular UAE Destinations
                    </h2>

                    <p className="max-w-2xl mx-auto text-gray-600 dark:text-gray-400">
                        Discover luxury resorts, city hotels and beachfront stays
                        across the UAE's most popular destinations.
                    </p>
                </div>

                {/* Destinations Grid */}
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">

                    {destinations.map((destination) => (
                        <Link
                            key={destination.id}
                            to={`/destination/${destination.slug}`}
                            className="group relative overflow-hidden rounded-3xl shadow-lg hover:shadow-2xl transition-all duration-500 hover:-translate-y-2"
                        >
                            {/* Image */}
                            <img
                                src={`https://uaediscountedhotels.com/uploads/destinations/${destination.image}`}
                                alt={destination.name}
                                className="h-80 w-full object-cover transform-gpu transition-transform duration-700 group-hover:scale-105"
                            />

                            {/* Overlay */}
                            <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/30 to-transparent" />

                            {/* Hotel Count Badge */}
                            <div className="absolute top-5 right-5">
                                <span className="bg-white/95 backdrop-blur-md px-4 py-2 rounded-full text-sm font-semibold text-gray-900 shadow">
                                    {destination.hotels_count} Hotels
                                </span>
                            </div>

                            {/* Content */}
                            <div className="absolute bottom-0 left-0 w-full p-6 text-white">

                                <div className="flex items-center gap-2 mb-2 text-white/90">
                                    <MapPin size={16} />
                                    UAE Destination
                                </div>

                                <h3 className="text-3xl font-bold mb-2">
                                    {destination.name}
                                </h3>

                                <p className="text-white/80 text-sm mb-4">
                                    Explore the best hotel deals and stays in{" "}
                                    {destination.name}.
                                </p>

                                <div className="inline-flex items-center gap-2 text-sm font-semibold bg-white/20 backdrop-blur-md px-4 py-2 rounded-full group-hover:bg-blue-600 transition">
                                    Explore Hotels
                                    <ArrowRight size={16} />
                                </div>

                            </div>
                        </Link>
                    ))}
                </div>

                {/* View All Destinations */}
                <div className="text-center mt-12">
                    <Link
                        to="/destinations"
                        className="inline-flex items-center gap-2 px-8 py-3 rounded-xl border-2 border-blue-600 text-blue-600 hover:bg-blue-600 hover:text-white transition font-semibold"
                    >
                        View All Destinations
                        <ArrowRight size={18} />
                    </Link>
                </div>

            </div>
        </section>
    );
}